var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-link',{attrs:{"type":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.openLink($event)}}},[_c('el-icon',{attrs:{"name":_vm.loading ? 'loading' : _vm.icon}}),_vm._v("\n  "+_vm._s(_vm.label)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }